import React from 'react'

const MailLink = (props) => (
    <svg width="7" height="7" viewBox="0 0 7 7" fill={props.color ? props.color : '#000000'}
         xmlns="http://www.w3.org/2000/svg">
        <g opacity={props.opacity ? props.opacity : '0.5'}>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M0 1.58903C0 1.22084 0.298477 0.922363 0.666667 0.922363H6C6.36819 0.922363 6.66667 1.22084 6.66667 1.58903V5.58903C6.66667 5.95722 6.36819 6.2557 6 6.2557H0.666667C0.298477 6.2557 0 5.95722 0 5.58903V1.58903ZM6 2.21186V5.58903H0.666667V2.21187L3.33333 3.98964L6 2.21186ZM5.7324 1.58903H0.934263L3.33333 3.18841L5.7324 1.58903Z"
            />
        </g>
    </svg>
)

export default MailLink
